import {Component, OnInit, ViewChild} from '@angular/core';
import {IppaymentComponent} from '../../../shared/components/ippayment/ippayment.component';
import {AddressDetailsComponent} from '../../../shared/components/address-details/address-details.component';
import {ApplicantDetailsComponent} from '../../../shared/components/applicant-details/applicant-details.component';
import {Steps} from 'primeng/primeng';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import {ApplicationFormBase} from '../../../shared/data-objects/application-form-base';

import {IppaymentService} from '../../../shared/services/ippayment.service';
import {Router} from '@angular/router';
import {LoginService} from '../../../shared/services/login.service';
import {FeeService} from '../../../shared/services/fee.service';
import {BoeService} from '../boe.service';
import {Boe} from '../boe';
import {WorkrequestBoeComponent} from '../workrequest-boe/workrequest-boe.component';
import {WorkrequestBoeViewmodel} from '../workrequest-boe-viewmodel';
import {UploadfilesViewmodel} from '../../../shared/viewmodels/uploadfiles-viewmodel';
import {ServiceBase} from '../../../shared/services/service-base';
import {FormControl, Validators} from '@angular/forms';
import {Meta} from '@angular/platform-browser';

const referenceNumberRE = /^[a-zA-Z0-9\-\/\.\:]+$/;

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: 'app-boe',
  templateUrl: './boe.component.html',
  styleUrls: ['./boe.component.css'],
  entryComponents: [ApplicantDetailsComponent, AddressDetailsComponent, IppaymentComponent]
})
export class BoeComponent extends ApplicationFormBase<Boe> implements OnInit {
  @ViewChild('WorkrequestComponent') workrequestComponent: WorkrequestBoeComponent;

  isRequesting: boolean;

  imageSourceUrl = ServiceBase.baseHref + '/assets/images/siteplan.png';

  private submitErrorMessageWorkRequest: string;

  refNumControl: FormControl;
  refNumControlLength = 11;

  constructor(protected loginService: LoginService, private feeService: FeeService,
              private boeService: BoeService, protected ipPaymentService: IppaymentService, protected router: Router, private meta: Meta) {
    super(boeService, loginService, ipPaymentService, router);
    this.refNumControl = new FormControl('', [Validators.maxLength(this.refNumControlLength), Validators.pattern(referenceNumberRE)]);
    this.meta.updateTag({ name: 'description', content: 'Request to build or retain a structure within one metre of a Greater Western Water asset and/or build over a Greater Western Water easement.' });
  }

  async ngOnInit() {
    let isTokenValid = await this.loginService.isTokenValid();
    if(!isTokenValid) {
      if(this.loginService.isGuestUserLoggedIn()) {
        this.loginService.guestLogin((ok: boolean)=>{
          this.initPfiAndBoe(this.workrequestComponent.totalOrderAmount);
        });
      } else {
        this.router.navigate(['/login']);
      }
    } else {
      await this.loginService.refreshToken();
      this.initPfiAndBoe(this.workrequestComponent.totalOrderAmount);
    }
  }

  onFeeCodesReceived(): void {
  }

  getTotalOrderAmount(): number {
    return this.workrequestComponent.totalOrderAmount;
  }

  get uploadfilesViewmodel(): UploadfilesViewmodel {
    return this.boeService.uploadfilesViewmodel;
  }

  get commitDisabled(): boolean {
    return (!this.workrequestComponent.isValid ||
      !this.boeService.agreedToTsAndCs ||
      this.applicant.invalid ||
      this.location.invalid ||
        this.refNumControl.invalid
    );
  }

  get architecturalPlansAttached(): boolean {
    return this.boeService.architecturalPlansAttached;
  }

  get engineeringPlansAttached(): boolean {
    return this.boeService.engineeringPlansAttached;
  }

  set architecturalPlansAttached(v: boolean) {
    this.boeService.architecturalPlansAttached = v;
  }

  set engineeringPlansAttached(v: boolean) {
    this.boeService.engineeringPlansAttached = v;
  }

  canGoNext(executeYes: any, executeNo: any): void {
    this.boeService.submitErrorMessage = '';

    if (this.activeIndex === 0) {
      this.navigateFromLocation(executeYes, executeNo);
    } else if (this.activeIndex === 1) {
      this.submitErrorMessageWorkRequest = '';
      if (!this.workrequestComponent.isValid) {
        this.submitErrorMessageWorkRequest = 'Please select at least one work request option';
        executeNo();
        return;
      } else {
        executeYes();
        return;
      }
    } else if (this.activeIndex === 2) {
      if (!this.uploadFileComponent.isValid) {
        executeNo();
      } else if (!this.architecturalPlansAttached) {
        this.boeService.submitErrorMessage += 'Please confirm architectural plan(s) are attached.';
        executeNo();
      } else if (!this.engineeringPlansAttached) {
        this.boeService.submitErrorMessage += 'Please confirm engineering plan(s) are attached.';
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 3) {
      if (this.applicant.invalid && this.applicant.displayErrorMessage().length > 0) {
        this.boeService.submitErrorMessage += this.applicant.displayErrorMessage();
        executeNo();
        return;
      }

      this.validTermsAndConditions(executeNo, executeYes);
    // } else if (this.isGuestUserLoggedIn && this.activeIndex === 4) {
    } else if (!this.loginService.isUserBillLater() && this.activeIndex === 4) {
      // this.navigateToPaymentWhenGuestUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount,
      //   this.submitApplication.bind(this));
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount,
        this.submitApplication.bind(this));
    } else {
      executeYes();
    }
  }

  canGoPrevious(): boolean {
    // if (this.isGuestUserLoggedIn && (this.activeIndex === 0 || this.activeIndex === 5)) {
    if (!this.loginService.isUserBillLater() && (this.activeIndex === 0 || this.activeIndex === 5)) {
      return false;
    }

    // if (!this.isGuestUserLoggedIn && this.activeIndex === 0) {
    if (this.loginService.isUserBillLater() && this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goNext(): void {
    // if ((!this.isGuestUserLoggedIn && this.activeIndex === 4) || (this.isGuestUserLoggedIn && this.activeIndex === 5)) {
    if ((this.loginService.isUserBillLater() && this.activeIndex === 4) || (!this.loginService.isUserBillLater() && this.activeIndex === 5)) {
      return;
    }

    this.canGoNext(() => {
      this.activeIndex++;
    }, () => {
    });
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.activeIndex--;
  }

  get boe(): Boe {
    return this.boeService.applicationData as Boe;
  }

  submitApplication(callback: any): void {
    if (this.commitDisabled) {
      this.boeService.submitErrorMessage = 'Please enter required information before submitting the application.';
      return;
    }
    if (!this.boeService.agreedToTsAndCs) {
      this.boeService.submitErrorMessage = 'Please select Terms and Conditions before submitting the application.';
      return;
    }
    this.setApplicantData();
    this.boeService.applicationData.workrequestDetails = this.workrequestComponent.workRequestViewModel.workrequestDetails;
    this.boeService.applicationData.locationAddress = this.location.addressDetails.locationAddress;
    this.boeService.applicationData.toUpperCase();
    this.doSubmit(callback);
  }

  newApplication(): void {
    window.location.reload();
    //super.newApplication();
    //this.uploadFileComponent.clearFiles();
    //this.workrequestComponent.markAsTouched();
    //this.refNumControl.markAsUntouched();
  }

  get workRequestViewModel(): WorkrequestBoeViewmodel {
    return this.boeService.workRequestViewModel;
  }

  private doSubmit(callback): void {
    this.executeSubmit('boe', callback, this.workrequestComponent.totalOrderAmount, this.uploadFileComponent, true);
  }

  get controlLabel(): string {
    return 'Upload plans';
  }

  get shouldDisplayLocation(): boolean {
    return this.activeIndex === 0;
  }

  get shouldDisplayWorkRequest(): boolean {
    return this.activeIndex === 1;
  }

  get shouldDisplayUploadFiles(): boolean {
    return this.activeIndex === 2;
  }

  get shouldDisplayApplicant(): boolean {
    return this.activeIndex === 3;
  }

  get shouldDisplayPaymentForm(): boolean {
    // return this.isGuestUserLoggedIn && this.activeIndex === 5;
    return !this.loginService.isUserBillLater() && this.activeIndex === 5;
  }

  get shouldDisplayNextButton(): boolean {
    // return (!this.isGuestUserLoggedIn && this.activeIndex !== 4) || (this.isGuestUserLoggedIn && (this.activeIndex !== 4 && this.activeIndex !== 5));
    return (this.loginService.isUserBillLater() && this.activeIndex !== 4) ||
           (!this.loginService.isUserBillLater() && (this.activeIndex !== 4 && this.activeIndex !== 5));
  }

  get shouldShowSubmitAndReview(): boolean {
    return this.activeIndex === 4;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/boe-form/boe/boe.component.ts